import { Sprout } from "lucide-react";

const ITEMS = [
  "Touch Grass",
  "Explore Wild Trails",
  "Reconnect With Earth",
  "Hacktoberfest Edition",
  "Discover Local Meadows",
  "Log Off. Lace Up.",
];

const Row = ({ hidden }) => (
  <div aria-hidden={hidden || undefined} className="flex items-center gap-12 pr-12">
    {ITEMS.map((item, i) => (
      <span
        key={i}
        className="flex items-center gap-12 whitespace-nowrap font-mono text-xs uppercase tracking-[0.3em] text-forest-300 sm:text-sm"
      >
        {item}
        <Sprout className="h-4 w-4 shrink-0 text-moss/50" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div className="marquee-mask overflow-hidden border-y border-forest-600/50 bg-forest-800/60 py-5">
      <div className="flex w-max animate-marquee">
        <Row />
        <Row hidden />
      </div>
    </div>
  );
}
